<n-tab #tab
    [hideHeader]="true"
    [activeIndex]="activeIndex">
    <n-tab-item>
        <ng-template nTemplate>
            <!-- 升级前评估、导包、备份页 -->
            <n-block class="pre-check-container" [title]="i18n.preUpGradeCheck">
                <n-lv [simpleMode]="SWITCH.IS_SIMPLE_MODE">
                    <!-- 升级模式：快速升级 -->
                    <n-lv-item [label]="i18n.systemUpgradeMode"
                        [helpContent]="i18n.systemUpgradeModeTip">
                        {{i18n.rapidUpgrade}}
                    </n-lv-item>
                    <!-- 当前版本 -->
                    <n-lv-item [label]="i18n.currentVersion">
                        {{currentVersion || UNPLACEHOLDER}}
                    </n-lv-item>
                    <!-- 升级前评估 -->
                    <n-lv-item [label]="i18n.upgradeCheckFile" class="label-stretch">
                        <n-radio-group
                            [(ngModel)]="updateCheckFile">
                            <n-radio id="update-script-true"
                                [disabled]="!updateCheckFile && currentProcess"
                                [value]="true">{{i18n.updateLabel}}</n-radio>
                            <n-radio id="update-script-false"
                                [disabled]="updateCheckFile && currentProcess"
                                [value]="false">{{i18n.notUpdateLabel}}</n-radio>
                        </n-radio-group>
                    </n-lv-item>
                    <n-lv-item [label]="i18n.checkFileLab" *ngIf="updateCheckFile">
                        <!-- 文件大小 10m  超时时间5分钟10秒 -->
                        <app-upgrade-file-upload
                            [restUrl]="checkFileUrl"
                            accept=".gz"
                            maxFileSize="10485760"
                            [timeout]="310000"
                            [disabled]="checkFileUploadDisabled | fn :currentProcess"
                            [getTargetVersion]="false"
                            (onFileSelected)="selectCheckFile()"
                            (onUploadStart)="startUploadCheckFile()"
                            (onUploadCompelete)="checkFileUploadCompelete($event)"
                            (onUploadFailed)="checkFileUploadFailed()">
                        </app-upgrade-file-upload>
                    </n-lv-item>
                    <!-- 目标版本 -->
                    <n-lv-item [label]="i18n.targetVersion">
                        <form [formGroup]="vm" [errorMessage]="errorMessage">
                            <n-form-item [labelHide]="true">
                                <input nInput formControlName="targetVersion" id="target-version-input">
                                <p class="sub" [innerHtml]="i18n.targetVersionTip"></p>
                            </n-form-item>
                        </form>
                    </n-lv-item>
                </n-lv>

                <button nButton
                    *ngIf="evaluateButtonShow | fn :currentProcess"
                    theme="primary"
                    [label]="i18n.evaluateBtn"
                    [disabled]="evaluateButtonDisabled | fn :currentProcess :updateCheckFile"
                    (click)="preCheck()">
                </button>

                <button nButton
                    *ngIf="retryButtonShow | fn :currentProcess"
                    theme="primary"
                    [label]="i18n.retryButton"
                    [disabled]="retryButtonDisabled | fn :currentProcess"
                    (click)="preCheck(true)">
                </button>
                <div class="upgrade-panel" [class.mt-20]="evaluateButtonShow | fn :currentProcess">
                    <div class="upgrade-panel-progress"
                        *ngIf="retryButtonShow | fn :currentProcess">
                        <div style="display:inline-block;width:70%;">
                            <p-progressBar [value]="upgradeStatus.checkProgress"
                                [color]="sysUpProgressDesc[currentProcess]?.color"
                                [showValue]="false"
                                [class.no-motion]="!progressMotion">
                            </p-progressBar>
                        </div>
                        <div class="check-result">
                            <svg class="icon"
                                *ngIf="evaluateProcessIconShow | fn :currentProcess"
                                [ngClass]="{'uploading': currentProcess === Progress.evaluating}">
                                <use [attr.xlink:href]="evaluateProcessIcon(currentProcess)" />
                            </svg>
                            {{evaluateProcessText | fn :currentProcess :upgradeStatus.checkProgress}}
                        </div>
                    </div>
                    <!-- 升级前评估数量 -->
                    <div class="num-container" *ngIf="retryButtonShow | fn :currentProcess">
                        <ul>
                            <li>
                                <div>{{count.all}}</div>
                                <div>{{i18n.total}}</div>
                            </li>
                            <li>
                                <div>{{count.suc}}</div>
                                <div>{{i18n.sucCount}}</div>
                            </li>
                            <li>
                                <div>{{count.fail}}</div>
                                <div>{{i18n.failedCount}}</div>
                            </li>
                            <li>
                                <div>{{count.ignore}}</div>
                                <div>{{i18n.ignoreCount}}</div>
                            </li>
                        </ul>
                    </div>
                    <!-- 升级前评估的框框 -->
                    <div class="upgrade-panel-detail" #detailContainerEle>
                        <ng-container *ngIf="checkDetails.length">
                            <div *ngFor="let checkDetail of checkDetails;let i = index" [ngClass]="{'upgrade-panel-detail-item': true, 'checking-item': +checkDetail.checkResult === CheckResult.Checking}">
                                <!-- 失败项 -->
                                <div class="upgrade-panel-detail-title">
                                    <div class="upgrade-panel-detail-icon">
                                        <svg class="icon" [ngClass]="{'uploading': +checkDetail.checkResult === CheckResult.Checking}">
                                            <use [attr.xlink:href]="str.getSvg | fn :+checkDetail.checkResult"/>
                                        </svg>
                                        <span style="color: #9EA4B3;margin-left:.04rem">{{str.getCheckItemValue | fn :checkDetail.checkItem}}</span>
                                    </div>
                                    <div class="upgrade-panel-detail-title-time">{{checkDetail.checkTime || UNPLACEHOLDER}}</div>
                                </div>
                                <!--  -->
                                <div *ngIf="checkDetail.nodeInfoArr"
                                    class="upgrade-panel-detail-icon">
                                    <div>
                                        <!-- 失败详情 -->
                                        <ng-container *ngIf="str.isCheckResultFailed | fn :+checkDetail.checkResult; else common">
                                            <span class="view-details" (click)="onShowCheckDetails(checkDetail?.checkItem)">
                                                <span class="error-red">{{i18n.failDetail}}</span>
                                            </span>
                                            <!-- 可忽略时，忽略按钮 -->
                                            <span *ngIf="str.ifShowSkip | fn :checkDetail.isSupportSkip :checkDetail.checkResult :currentProcess"
                                                class="upgrade-panel-detail-icon-btn"
                                                (click)="onSkipCheckDetails(i)">
                                                {{i18n.skip}}
                                            </span>
                                            <!-- 已忽略 ????????????????? 失败了还有已忽略？？？？？？？？？？？？？？？？？？？-->
                                            <span *ngIf="+checkDetail.checkResult === CheckResult.Ignore"
                                                class="upgrade-panel-detail-icon-btn ignorestyle">
                                                {{i18n.skipped}}
                                            </span>
                                        </ng-container>
                                        <!-- 成功详情 -->
                                        <ng-template #common>
                                            <span  class="view-details" (click)="onShowCheckDetails(checkDetail?.checkItem)">
                                                <span class="common-blue">{{i18n.detail}}</span>
                                            </span>
                                            <!-- 已忽略 -->
                                            <span *ngIf="+checkDetail.checkResult === CheckResult.Ignore"
                                                class="upgrade-panel-detail-icon-btn ignorestyle">
                                                {{i18n.skipped}}
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <n-nodata
                            [text]="i18n.noDataTip"
                            class="mt-5"
                            *ngIf="!checkDetails.length">
                        </n-nodata>
                    </div>
                </div>
            </n-block>
        </ng-template>
    </n-tab-item>
    <n-tab-item>
        <ng-template nTemplate>
            <!-- 备份导出 -->
            <n-block [title]="i18n.backupLab">
                <n-tip type="warning" [content]="backupTip" class="mb-2">
                </n-tip>
                <ng-container *ngIf="isShowExport">
                    <div class="upgrade-export" >
                        <div class="icon-item">
                            <!-- 微存储直通模式，屏蔽license -->
                            <ng-container *ngIf="!SWITCH.IS_DIRECT_MODE">
                                <div class="icon-text">
                                    <svg class="icon">
                                        <use [attr.xlink:href]="'#app-icon-upgrade-license'"></use>
                                    </svg>
                                    <div class="export-text">{{i18n.licenseLab}}</div>
                                </div>
                                <svg class="pulsign-icon">
                                    <use [attr.xlink:href]="'#app-icon-upgrade-pulsign'"></use>
                                </svg>
                            </ng-container>
                            <div class="icon-text">
                                <svg class="icon">
                                    <use [attr.xlink:href]="'#app-icon-upgrade-database'"></use>
                                </svg>
                                <div class="export-text">{{i18n.configurationDatabaseLab}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="export-btn" *ngIf="!isExportSucceed">
                        <button pButton type="text"
                            icon="icon-download"
                            [label]="i18n.exportLink"
                            [loading]="backupLoading"
                            (click)="export()">
                        </button>
                    </div>
                    <div class="export-succeed" *ngIf="isExportSucceed && isExportLicenseSucceed">
                        <svg class="icon">
                            <use [attr.xlink:href]="'#icon-status-succeed'" />
                        </svg>
                        {{i18n.finishBackupLab}}
                        <button nButton
                            [theme]="'text'"
                            (click)="export()"
                            [loading]="backupLoading">
                            {{i18n.backupAgainBtn}}
                        </button>
                    </div>
                    <div class="export-succeed" *ngIf="!isExportLicenseSucceed">
                        <svg class="icon">
                            <use [attr.xlink:href]="'#icon-status-succeed'" />
                        </svg>
                        {{i18n.finishDatabaseBackupLab}}
                        <button nButton
                            [theme]="'text'"
                            (click)="export()"
                            [loading]="backupLoading">
                            {{i18n.backupAgainBtn}}
                        </button>
                    </div>
                </ng-container>
            </n-block>
        </ng-template>
    </n-tab-item>
    <n-tab-item>
            <!-- 升级 -->
        <ng-template nTemplate>
            <n-block [title]="i18n.upgrade">
                <div *ngIf="upgradeShow | fn :currentProcess : isExportSucceed">
                    <n-lv [simpleMode]="SWITCH.IS_SIMPLE_MODE">
                        <!-- 上传文件 大小4G 超时1小时10秒 -->
                        <n-lv-item [label]="i18n.upgradePackage">
                            <app-upgrade-file-upload
                                [restUrl]="uploadUrl"
                                accept=".tgz"
                                maxFileSize="4294967296"
                                [timeout]="3610000"
                                [getTargetVersion]="true"
                                [packageType]="PackageTypeE.SystemSoftware"
                                [disabled]="packageUploadDisabled | fn :currentProcess :hotpatchUploadEnable"
                                (onUploadStart)="startUploadPackage()"
                                (onUploadCompelete)="packageUploadCompelete($event)"
                                (onUploadFailed)="packageUploadFailed()">
                            </app-upgrade-file-upload>
                        </n-lv-item>
                        <!-- 目标版本 -->
                        <n-lv-item [label]="i18n.targetVersion">
                            {{packageTargetVersion}}
                        </n-lv-item>
                        <!-- 评估版本 -->
                        <n-lv-item [label]="i18n.evaluationVersionLab"
                            [helpContent]="i18n.evaluationVersionTip">
                            {{vm?.value.targetVersion | unknownPlaceholder}}
                        </n-lv-item>
                        <!-- 热补丁升级 -->
                        <n-lv-item [label]="i18n.hotpatchInUpgrade"
                            class="label-stretch"
                            *ngIf="hotPatchUploadShow | fn :currentProcess"
                            [helpContent]="i18n.hotpatchSameTimeTip">
                                <n-checkbox [(ngModel)]="hotpatchUploadEnable"
                                    (onChange)="hotpatchUploadEnableChange($event)"
                                    [disabled]="hotpatchUploadEnableDisabled | fn :currentProcess :hotpatchUploadEnable">
                                </n-checkbox>
                        </n-lv-item>
                        <n-lv-item [label]="i18n.hotpatchPackage"
                            *ngIf="hotpatchUploadEnable">
                            <!-- 文件大小 700m  超时时间1小时10秒 -->
                            <app-upgrade-file-upload
                                [restUrl]="hotpatchUrl"
                                accept=".tgz"
                                maxFileSize="734003200"
                                [timeout]="3610000"
                                [getTargetVersion]="true"
                                [packageType]="PackageTypeE.HotpatchDuringUpgrade"
                                [disabled]="hotPatchUploadDisabled | fn :currentProcess"
                                (onUploadStart)="startUploadHotpatch()"
                                (onUploadCompelete)="hotpatchUploadCompelete($event)"
                                (onUploadFailed)="hotpatchUploadFailed()">
                            </app-upgrade-file-upload>
                        </n-lv-item>
                        <n-lv-item [label]="i18n.targetVersion"
                            *ngIf="hotpatchUploadEnable">
                            {{hotpatchTargetVersion}}
                        </n-lv-item>
                    </n-lv>
                    <n-tip
                        [content]="i18n.upgrademsg">
                    </n-tip>
                </div>
            </n-block>
        </ng-template>
    </n-tab-item>
</n-tab>
